const toolbarConfiguration = {
  filterMap: {
    status: {
      name: "status",
      id: "status",
      label: "Status",
      filterId: "status",
      detailId: "status",
      filterCallId: "status",
    },
    category: {
      name: "category",
      id: "category",
      label: "Categories",
      filterId: "category",
      detailId: "sku_grp_id",
      filterCallId: "sku_grp_id",
      sort: "name"
    },
    sku: {
      name: "sku_cnt",
      id: "sku_cnt",
      label: "WRINs",
      filterId: "sku",
      detailId: "sku_id",
      filterCallId: "wrin_id",
      sort: "alias"
    },
    tier2_skus: {
      name: "tier2_skus",
      id: "tier2_skus",
      label: "Raw Materials",
      filterId: "tier2_skus",
      detailId: "sku_id",
      filterCallId: "tier2_sku_id",
      sort: "alias"
    },
    tier2_suppliers: {
      name: "tier2_suppliers",
      id: "tier2_suppliers",
      label: "Tier 2 Suppliers",
      filterId: "tier2_suppliers",
      detailId: "geonode_id",
      filterCallId: "tier2_supp_id",
      sort: "alias"
    },
    supplier: {
      name: "supp_cnt",
      id: "supp_cnt",
      label: "Supplier WSI",
      filterId: "supplier",
      detailId: "geonode_id",
      filterCallId: "supp_id",
      sort: "alias"
    },
    DC: {
      name: "dc_cnt",
      id: "dc_cnt",
      label: "DC / Hubs",
      filterId: "DC",
      detailId: "geonode_id",
      filterCallId: "dc_id",
      sort: "name"
    },
    risk_type: {
      name: "risk_type",
      id: "risk_type",
      label: "Risk Type",
      filterId: "risk_type",
      detailId: "id",
      filterCallId: "risk_type",
    },
    supplier_org: {
      name: "supplier_org",
      id: "supp_grp_id",
      label: "Supplier Org",
      filterId: "Supplier Org",
      detailId: "org_id",
      filterCallId: "supp_grp_id",
      sort: "name"
    },
    assembly_item: {
      name: "assembly_item",
      id: "assembly_item",
      label: "Assembly Item",
      filterId: "Assembly Item",
      detailId: "sku_grp_id",
      filterCallId: "assembly_item_id",
      sort: "alias"
    },
    incident_type: {
      name: "incident_type",
      id: "incident_type",
      label: "Incident Type",
      filterId: "Incident Type",
      detailId: "event_grp_id",
      filterCallId: "incident_type_id",
      sort: "name"
    },
    issue_type: {
      name: "issue_type",
      id: "issue_type",
      label: "Issue Type",
      filterId: "Issue Type",
      detailId: "event_grp_id",
      filterCallId: "issue_type_id",
      sort: "name"
    },
    product_group_manager: {
      name: "product_group_manager",
      id: "product_group_manager",
      label: "Product Manager",
      filterId: "Product Manager",
      detailId: "product_group_manager",
      filterCallId: "product_group_manager",
      sort: "name"
    },
    fsc_manager: {
      name: "fsc_manager",
      id: "fsc_manager",
      label: "Field Manager",
      filterId: "Field Manager",
      detailId: "fsc_manager",
      filterCallId: "fsc_manager",
      sort: "name"
    },
    product_type: {
      name: "product_type",
      id: "product_type",
      label: "Product Type",
      filterId: "Type",
      detailId: "sku_grp_id",
      filterCallId: "type_id",
      sort: "name"
    }
  },
};

export default toolbarConfiguration;
